import React, { useRef, useEffect } from "react";
import classNames from "classnames";
import v4 from "uuid";
import { COLORS } from "../../constants/colors";
import CheckMark from "../svgs/checkMark/checkMark";
import { Tooltip as ReactTooltip } from "react-tooltip";

const ProductTourItem = ({
  story,
  selectStory,
  selectedStory,
  stepIndex,
  stepNumber,
  isExpanded,
  toggleExpansion,
}) => {
  const panel = useRef();

  useEffect(() => {
    const { current } = panel;
    if (current) {
      if (isExpanded) {
        current.style.maxHeight = current.scrollHeight + "px";
      } else {
        current.removeAttribute("style");
      }
    }
  }, [isExpanded]);

  const toggleStep = () => {
    toggleExpansion(story.uuid);
  };

  const numberCircle = {
    borderRadius: "50%",
    width: "36px",
    padding: "8px",
    background: "transparent",
    border: `1px solid ${COLORS.YELLOW}`,
    color: COLORS.YELLOW,
    textAlign: "center",
    fontSize: "32px",
    position: "absolute",
  };

  const { title, steps, uuid, disabled, completed } = story;

  const stepColor = (index) =>
    stepIndex >= index && uuid === selectedStory && COLORS.YELLOW;
  const tooltip = disabled
    ? "You have to login <br /> or you have not completed <br /> previous steps"
    : "";
  return (
    <div className={classNames("panel-wrapper", { open: isExpanded })}>
      {completed ? <CheckMark /> : <div style={numberCircle}>{stepNumber}</div>}
      <a data-for="main" data-tip={tooltip} data-iscapture="false">
        <button
          disabled={disabled ? "disabled-story" : ""}
          className="accordion product_tour_accordion"
          onClick={toggleStep}
          id={v4()}
        >
          <span style={{ color: disabled ? "#9fc4d2" : "#fff" }}>
            {title.toUpperCase()}
          </span>
        </button>
      </a>
      <ReactTooltip
        id="main"
        place={"top"}
        type={"dark"}
        effect={"solid"}
        multiline={true}
      />

      <div ref={panel} className={"panel faq"}>
        {steps.map((step, index) => {
          return (
            <p
              key={`${uuid}-step-${index}`}
              style={{
                color: stepColor(index),
              }}
            >
              {index + 1} {step.content}
            </p>
          );
        })}
        <button
          style={{
            backgroundColor: disabled ? "#ccc" : COLORS.YELLOW,
            color: disabled ? "#666" : COLORS.DARK_BLUE,
            cursor: disabled ? "not-allowed" : "pointer",
            border: "none",
            borderRadius: "4px",
            padding: "8px 16px",
            marginTop: "10px",
            fontSize: "14px",
            fontWeight: "bold",
            transition: "all 0.2s ease",
            boxShadow: disabled ? "none" : "0 2px 4px rgba(0, 0, 0, 0.1)",
            opacity: disabled ? 0.6 : 1,
          }}
          onMouseEnter={(e) => {
            if (!disabled) {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.15)";
            }
          }}
          onMouseLeave={(e) => {
            if (!disabled) {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
            }
          }}
          onClick={() => !disabled && selectStory(uuid)}
          disabled={disabled}
        >
          START STORY
        </button>
      </div>
    </div>
  );
};

export default ProductTourItem;
